module.exports = __webpack_public_path__ + "media/images/boxes/pup-box500-ca97718a2c1b9c0d3890c33a773f52b7.png";